export const QUIZ_CATEGORIES = {
  Data: {
    id: "Data",
    label: "Data & IA",
    color: "var(--electric-blue)",
  },
  Dev: {
    id: "Dev",
    label: "Dev & Cloud",
    color: "var(--volt)",
  },
  Cyber: {
    id: "Cyber",
    label: "Cybersécurité",
    color: "var(--violet-plum)",
  },
  Digital: {
    id: "Digital",
    label: "Digital",
    color: "var(--magenta)",
  },
} as const;

export type QuizCategoryId = keyof typeof QUIZ_CATEGORIES;

export enum QuizSubCategory {
  METIER = "Quiz métier",
  TECHNO = "Quiz technologique",
}
